import moment                            from 'moment'
import { uploadConsentsActionConstants } from '../actions/uploadConsentsActions'
import { objectWithoutTheseKeys }        from '../utils/dataUtils'

const initialState = {}

function removeConsent (state, action) {
  const { ins, psId } = action
  
  const {
          [psId]: psConsents,
          ...consents
        } = state
  
  return {
    [psId]: objectWithoutTheseKeys(psConsents, [ins]),
    ...consents
  }
}

function addConsent (state, action) {
  const { ins, psId, fullName, birthday } = action
  return {
    ...state,
    [psId]: {
      ...state[psId],
      [ins]: {
        fullName,
        birthday,
        timestamp: moment().unix()
      },
    }
  }
}

export function uploadConsents (state = initialState, action) {
  switch (action.type) {
    case uploadConsentsActionConstants.REMOVE_CONSENT:
      return removeConsent(state, action)
    case uploadConsentsActionConstants.ADD_CONSENT:
      return addConsent(state, action)
    default:
      return state
  }
}
